var _defs, _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_586",
    "data-name": "Gruppe 586",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.864,
    height: 86.075,
    viewBox: "0 0 155.864 86.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M0,0H155.864V-86.075H0Z",
    transform: "translate(0 86.075)",
    fill: "#131b2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M0-63.975H72.7v-22.1H0Z",
    transform: "translate(0 86.075)",
    fill: "#131b2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M83.166-63.975h72.7v-22.1h-72.7Z",
    transform: "translate(0 86.075)",
    fill: "#131b2e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M0-31.987H72.7v-22.1H0Z",
    transform: "translate(0 86.075)",
    fill: "#131b2e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4",
    transform: "translate(83.168 31.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M0,0C0,14.836-9.469,27.043-20.964,27.043H-72.7V4.945h45.812A5.1,5.1,0,0,0-22.1,0a5.025,5.025,0,0,0-4.7-4.943H-72.7v-22.1h51.732C-9.446-27.043,0-14.836,0,0",
    transform: "translate(72.696 27.043)",
    fill: "#131b2e"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M0,0H72.7V-22.1H0Z",
    transform: "translate(0 86.075)",
    fill: "#131b2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.07f3ed75afea444db90183a9b2c10703.svg";
export { ForwardRef as ReactComponent };